export default () => {
  const maskArray = new Array(25).fill(/\d/);
  maskArray[0] = "(";
  maskArray[4] = ") ";
  maskArray[8] = "-";
  maskArray[13] = /\s/;
  maskArray[14] = "ext. ";
  return maskArray;
};
